/**
 * This object is used to gather essential information from backend server's response !
 * The status is the http status code (ex.: 200 or 500)
 * The payload is the object sent by the backend server
 * The messageKey is the error message KEY sent and translated to show on the FRONT. If status is 2XX no messageKey
 * @author Florent Barriol.
 */

export class Response {
    constructor(status, payload = {}, message = '', data = null) {
        this._status = status;
        this._payload = payload;
        this._message = message;
        this._data = data
    }

    get status() {
        return this._status;
    }

    get payload() {
        return this._payload;
    }

    get message() {
        return this._message;
    }

    get data() {
        return this._data;
    }

    set status(status) {
        this._status = status;
    }

    set payload(payload) {
        this._payload = payload;
    }

    set message(message) {
        this._message = message;
    }

    set data(data) {
        this._data = data;
    }
}



// WEBPACK FOOTER //
// ./src/objects/Response.js